import type { IssueTableRelationColumn } from './types'

interface ColumnEdge {
  node: { name: string; enabled: boolean }
}

interface RelationEdge {
  node: { id: string; name: string; visibleInTable: boolean }
}

interface IssueWithRelationValues {
  selectedRelationOptions?: {
    name: string
    relation: { id: string }
  }[]
}

/** Names of the built-in columns the company still shows. */
export function enabledColumnNames(edges: ColumnEdge[]): Set<string> {
  const names = new Set<string>()
  for (const edge of edges) {
    if (edge.node.enabled) names.add(edge.node.name)
  }
  return names
}

/** Relations promoted to their own column, in the order they render. */
export function visibleRelationColumns(
  edges: RelationEdge[]
): IssueTableRelationColumn[] {
  return edges
    .map(edge => edge.node)
    .filter(relation => relation.visibleInTable)
    .map(relation => ({ id: relation.id, name: relation.name }))
    .sort((a, b) => a.name.localeCompare(b.name))
}

/**
 * The options chosen for `relationId` on this issue, as one cell value. A
 * multiple choice relation can hold several, so they are joined rather than
 * showing only the first.
 */
export function relationValueFor(
  issue: IssueWithRelationValues,
  relationId: string
): string | null {
  const names = (issue.selectedRelationOptions ?? [])
    .filter(candidate => candidate.relation.id === relationId)
    .map(candidate => candidate.name)
  return names.length > 0 ? names.join(', ') : null
}
